import React, { Fragment } from "react";
import { Button, Image, Table } from "react-bootstrap";
import moment from "moment";
function Processed(props) {
  return (
    <div>
      <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
        <Table className="HideShowTable enMinWidth900">
          <thead>
            <tr className="super_admin_all_users_table_head">
              <th style={{ width: "15%" }} className="f12-700">
                User Name
              </th>
              <th style={{ width: "12%" }} className="f12-700">
                Mobile Number
              </th>
              <th style={{ width: "12%" }} className="f12-700">
                Date
              </th>
              <th style={{ width: "11%" }} className="f12-700">
                Settle Amount
              </th>
              <th style={{ width: "18%" }} className="f12-700">
                Bank Details
              </th>
              <th style={{ width: "14%" }} className="f12-700">
                Reference ID
              </th>
              <th style={{ width: "14%" }} className="f12-700">
                Status
              </th>
            </tr>
          </thead>
          {props.filteredData?.map((transaction, index) => (
            <Fragment key={index}>
              {transaction && transaction.status === "PROCESSED" ? (
                <tbody key={index}>
                  <tr className="super_admin_all_users_table_body">
                    <td style={{ width: "15%" }}>
                      <div className="d-flex align-items-center">
                        <div className="f12-400">
                          {`${transaction?.user_id?.first_name || ""} ${transaction?.user_id?.last_name}`}
                        </div>
                      </div>
                    </td>
                    <td style={{ width: "12%" }}>
                      <div className="d-flex align-items-center">
                        <div className="f12-400">
                          {transaction?.user_id?.mobile_number}
                        </div>
                      </div>
                    </td>
                    <td style={{ width: "12%" }}>
                      <div className="f12-400">
                        {moment(transaction && transaction.createdAt).format(
                          "Do MMMM ,YYYY"
                        )}
                        <br />
                        {moment(transaction && transaction.createdAt).format(
                          "LT"
                        )}
                      </div>
                    </td>
                    <td style={{ width: "11%" }}>
                      <div className="f12-400">
                        ₹ {transaction?.settleBalance}
                      </div>
                    </td>
                    <td style={{ width: "18%" }}>
                      <div className="f10-400">
                        {transaction?.bank_id.bank_name}
                      </div>
                      <div className="f10-400">
                        {transaction?.bank_id.account_holder_name}
                      </div>
                      <div className="f10-400">
                        {atob(transaction?.bank_id.account_number)}
                      </div>
                      <div className="f10-400">
                        {atob(transaction?.bank_id.ifsc_code)}
                      </div>
                    </td>
                    <td style={{ width: "14%" }}>
                      <div className="f10-400">{transaction.referenceId}</div>
                    </td>
                    <td style={{ width: "14%" }}>
                      <div className="enPendingLBL">Processed</div>
                    </td>
                  </tr>
                </tbody>
              ) : (
                <> </>
              )}{" "}
            </Fragment>
          ))}
        </Table>
      </div>
    </div>
  );
}

export default Processed;
